import * as yup from 'yup'

export const getBackupSettingsValidationSchema = () => {
    return {
        is_backup_enabled: yup
            .boolean()
            .required(),
        backup_interval_days: yup
            .number()
            .integer()
            .max(Number.MAX_SAFE_INTEGER)
            .min(0)
            .nullable(),
        start_time: yup.string().nullable(),
        storage_limit_gb: yup
            .number()
            .max(Number.MAX_SAFE_INTEGER)
            .min(0)
            .nullable(),
        lifetime_days: yup
            .number()
            .integer()
            .max(Number.MAX_SAFE_INTEGER)
            .min(0)
            .nullable(),
        retry_attempts: yup
            .number()
            .integer()
            .max(Number.MAX_SAFE_INTEGER)
            .min(0)
            .nullable(),
        retry_delay_sec: yup
            .number()
            .integer()
            .max(Number.MAX_SAFE_INTEGER)
            .min(0)
            .nullable(),
    }
}
